<div class="col-1 d-none d-lg-block d-xl-block col-md-auto pr-4 pl-0" [style.height]="altura" [style.float]="posicao"
  style="width: 40px; border-right: 1px solid #ebebeb; margin-right: 5px">
  <img src={{imagem}} alt="divisor" height="32x" width="32px">
</div>